import { useMemo } from 'react'

import { last } from 'lodash'

import { findTreeMatches } from '@eastcoal/common/utils/array'

import { ResourceConfig } from '../types/resource'

import { useMatches } from './useMatches'

/**
 * 查找匹配的菜单项
 *
 * @param resources 菜单配置
 * @returns 匹配的菜单项
 */
export const useMatchedResources = (resources: ResourceConfig[]) => {
  const matches = useMatches()
  const keys = last(matches)?.handle.keys
  const result = useMemo(
    () =>
      keys
        ? findTreeMatches(
            resources,
            keys,
            (resource, key) => resource.key === key
          )
        : [],
    [resources, keys]
  )

  return result
}
